<div class="row w-100 align-itens-start">
  <div class="legend">
    <div class="item cdi">
      <i class="fas fa-circle mr-2"></i> CDI
    </div>
    <div class="item poupanca">
      <i class="fas fa-circle mr-2"></i> Poupança
    </div>
    <div class="item vivamais">
      <i class="fas fa-circle mr-2"></i> Viva Mais
    </div>
  </div>
  <div class="chartFilters">
    <div class="{{classe12}}" (click)="buscaDados(12)">12M</div>
    <div class="{{classe24}}" (click)="buscaDados(24)">24M</div>
    <div class="{{classe36}}" (click)="buscaDados(36)">36M</div>
    <!-- <div class="item select">
    Invervalo Personalizado <i class="fas fa-angle-down"></i>
  </div> -->
</div>
</div>

<div class="responsive-chart">
  <div class="chart-wrapper">
    @if (dadosCarregados) {
      <canvas
        baseChart
        height="70"
        [datasets]="lineChartData"
        [labels]="lineChartLabels"
        [options]="lineChartOptions"
        [legend]="lineChartLegend"
        [plugins]="lineChartPlugins"
        >
      </canvas>
    }
  </div>
</div>